module.exports = __webpack_public_path__ + "img/gtc100s.e32a464b.png";